import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setPersonalInfoSetting, setRelationshipsSetting } from '../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../root/tcsm-model';

export function useAccountInfoSettings(personalInfoSettingId: string, relationshipsSettingId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	useEffect(() => {
		if (!epiApiState?.personalInfoSettingState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, personalInfoSettingId, { guid }, language, false, setPersonalInfoSetting));
		}
		if (!epiApiState?.relationshipsSettingState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, relationshipsSettingId, { guid }, language, false, setRelationshipsSetting));
		}
	}, []);

	return epiApiState?.personalInfoSettingState?.contentLoaded && epiApiState?.relationshipsSettingState?.contentLoaded;
}